import { FC } from 'react';
import { SelectedLesson } from '../../models/OtherResources';

interface Props {
  lesson: SelectedLesson;
}

export const OtherLearningResources: FC<Props> = ({ lesson }) => {
  return (
    <>
      <div className="w-full flex flex-column justify-content-start align-items-start nc_block">
        <h1>{lesson.name}</h1>
        <h3>{lesson.summary}</h3>
        {lesson.url && <iframe className="w-full" style={{ height: '60vh' }} src={lesson.url} />}
      </div>
    </>
  );
};
